import React, { useEffect, useMemo } from "react";
import "./TwitterData.css";
import { useLoadTypeContentData } from "../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent";
import { getContentFeedDateWindowFromComponent } from "../../../../Screens/DashboardView/StayUpToDate/AddComponentPicker/contentFeedTimeframe";
import { StayFeedLoadingPlaceholder } from "../../../../Screens/DashboardView/MasterTemplateEditor/WebsiteLibFeedSkeleton";
import { useParams } from "react-router-dom";
import {
  handleFirstImage,
  updateIsEmptyStatus,
} from "../../../../Utils/StayUpToDate/RenderComponent";
import { useDomLoaded } from "../../../../hooks/DomLoadedContext";
import PostTemplate from "../CommonComponents/PostTemplate";
import { FeedSectionEmptyState } from "../FeedSectionEmptyState";
import { websiteEditorFeedEmptyMessage } from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";

const TwitterData = (props: any) => {
  let platform = props.platform || "twitter";
  let type = props.type || "TWEET";
  const itemsPerPage = 3;

  const param = useParams();

  const {
    user_id,
    username,
    title,
    handleRedirect,
    brand_color,
    isHandleNavigate,
    component,
    removedPostIds,
    isLinks,
    from,
    designTokens,
    templateGridLoaderProps,
    showEmptyInEditor = false,
  } = props;
  const contentDateWindow = useMemo(
    () => getContentFeedDateWindowFromComponent(component),
    [component?.details, component?.id]
  );

  const { isLoading: TwitterDataLoading, data: TwitterData, total_count }: any =
    useLoadTypeContentData(
      username,
      user_id,
      platform,
      type,
      removedPostIds,
      component?.content_order,
      component?.custom_order?.split(","),
      component?.shoppable_content_filter,
      component?.pinned_posts?.split(",") || [],
      component?.shoppable_status_filter || "all",
    "default",
    "default",
    true,
    contentDateWindow
  );

  // Process pages data similar to TiktokData and ReelsData pattern
  // Flatten pages array: each page is { data: [...], total_count: ..., originalDataLength: ... }
  // Extract data arrays from each page and flatten them
  const processedData = useMemo(() => {
    if (!TwitterData?.pages || !Array.isArray(TwitterData.pages)) return [];

    // Flatten pages: extract data array from each page object
    const flattened = TwitterData.pages.flatMap((page: any) => page?.data || []);

    return flattened.filter((element: any) => element !== undefined);
  }, [TwitterData?.pages]);
 
  const domLoaded = useDomLoaded();
  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!TwitterDataLoading) {
        if (!processedData || processedData.length === 0 || total_count === 0) {
          if (!showEmptyInEditor) {
            await updateIsEmptyStatus(title, user_id, component.id, from);
          }
        } else {
          await handleFirstImage(
            title,
            component?.id,
            processedData[0],
            user_id,
            from
          );
        }
      }
    };
    checkEmptyStatus();
  }, [TwitterDataLoading, processedData, total_count, title, user_id, component?.id, from]);
  
  return (
    <>
      {TwitterDataLoading || !domLoaded ? (<StayFeedLoadingPlaceholder
          designTokens={designTokens}
          from={from}
          component={component}
          templateGridLoaderProps={templateGridLoaderProps}
        />) : (
        <>
          {processedData && processedData.length > 0 && total_count > 0 ? (
            <PostTemplate
              processedData={processedData}
              total_count={total_count}
                component={component}
                user_id={user_id}
                username={username}
              handleRedirect={handleRedirect}
              brand_color={brand_color}
              title={title}
                from={from}
                designTokens={designTokens}
              type={type}
              itemsPerPage={itemsPerPage}
              platform={platform}
                pinnedPostIds={component?.pinned_posts?.split(",") || []}
              isLinks={isLinks}
              />
          ) : showEmptyInEditor ? (
            <FeedSectionEmptyState
              title={title}
              designTokens={designTokens}
              message={websiteEditorFeedEmptyMessage("platform", { platform: "X" })}
            />
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default TwitterData;
